/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Shipment = {
    id?: number;
    /**
     * Used for tracking order and get shipment details from ordmngAPI
     */
    order_id?: string;
    user_id?: string;
    /**
     * User note for shipment
     */
    note?: string | null;
    cost?: number;
    created_at?: string;
    updated_at?: string;
    state?: Shipment.state;
    package_id?: number | null;
    combinedPackage_id?: number | null;
    reciver_Address_id?: number | null;
};
export namespace Shipment {
    export enum state {
        DRAFT = 'DRAFT',
        REQUESTED = 'REQUESTED',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
        DONE = 'DONE',
    }
}

